{
  "Home": "Hem",
  "All learning": "Alla lärobjekt",
  "Profile": "Profil",
  "Network": "Nätverk",
  "Notifications": "Notiser",
  "Admin": "Admin",
  "Manager": "Chef",
  "Logout": "Logga ut",
  "Ongoing learnings": "Pågående",
  "My learning": "Mitt lärande",
  "Assigned": "Tilldelade",
  "Saved by me": "Sparat av mig",
  "Completed": "Avslutade",
  "Approval": "Godkännande",
  "Order history": "Historik ansökningar",
  "Assign": "Tilldela",
  "Groups": "Grupper",
  "Users": "Användare",
  "Teams": "Team",
  "Time tracking": "Importera tid",
  "Exit admin": "Exit Admin",
  "Exit": "Exit Admin",
  "Content": "Content",
  "People": "Användare",
  "Journeys": "Journeys",
  "Approve": "Godkänna",
  "Analyze": "Analysera",
  "No notifications": "Inga notifieringar",
  "No ongoing learnings": "Inga pågående lärobjekt",
  "Give us feedback": "Ge oss feedback",
  "Go to previous campus": "Gå till tidigare campus",
  "Analytics": "Analytics",
  "Close the menu": "Stäng menyn",
  "Open the menu": "Öppna menyn",
  "Clear notifications": "Rensa notifieringar",
  "Campus Online Data": "Campus Online Data",
  "Explore": "Utforska",
  "Search learning items": "Sök lärobjekt",
  "Site logo": "Logotyp webbplats",
  "View all learning items": "Visa alla lärobjekt",
  "Top providers": "Partners",
  "View all providers": "Visa partners"
}
